import React, { useEffect, useState } from 'react';

import { Translate } from './Translate/Translate';

const Header = () => {
  const [initialLanguage, setinitialLanguage] = useState(null);

  const getCookie = name => {
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ').reduce((acc, current) => {
      const [key, value] = current.split('=');
      acc[key] = value;
      return acc;
    }, {});

    return cookies[name];
  };

  const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  };

  useEffect(() => {
    const cookie = getCookie('googtranslate');
    if (!cookie) {
      setCookie('googtranslate', 'en', 1000);
    } else {
      setinitialLanguage(cookie);
    }
  }, []);

  return (
    <div className="tranlate-wrap">
      {initialLanguage && (
        <Translate
          apiKey="AIzaSyA6GxtOCzzE2QWbElOyFojuy2Uxaysif-Y"
          initialLanguage={initialLanguage}
          setCookie={setCookie}
        />
      )}
      {!initialLanguage && <div className="no-lang">&nbsp;</div>}
    </div>
  );
};

export default Header;
